import React from 'react';
export function Footer() {
  return <footer className="bg-black pt-20 pb-28 md:pb-10 border-t border-white/10 px-4 sm:px-6 lg:px-8" data-id="element-88" data-mp="32wd2cf6gdjt0">
      <div className="max-w-7xl mx-auto" data-id="element-89" data-mp="3ggk7gsifd7yh">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-90" data-mp="32o4d0g3lai96">
          {/* Brand */}
          <div className="md:col-span-1" data-id="element-91" data-mp="36p6cmy1f4wbo">
            <div className="inline-flex flex-col items-center leading-none mb-6" data-id="element-92" data-mp="36q93x72nl0s4">
              <span className="text-2xl font-normal tracking-[0.4em] text-white pl-[0.4em]" data-id="element-93" data-mp="3ug3etj3ewf9q">
                VANTIX
              </span>
              <span className="text-[10px] font-normal tracking-[0.3em] text-white/90 border-t border-amber-400 pt-1.5 mt-1.5 w-full text-center pl-[0.3em]" data-id="element-94" data-mp="37xuse6oxwgy">
                CREDIT SOLUTIONS
              </span>
            </div>
            <p className="text-white/50 font-light leading-relaxed text-sm mb-6" data-id="element-95" data-mp="29z6woiixuvj2">
              Transformamos tu crédito y desbloqueamos tu acceso a
              financiamiento. Sistema probado, resultados garantizados.
            </p>
          </div>

          {/* Servicios */}
          <div data-id="element-96" data-mp="3lbddywk4gfne">
            <h3 className="text-white font-semibold mb-5 text-sm tracking-wide" data-id="element-97" data-mp="3gah1vvpm9n6w">
              Servicios
            </h3>
            <ul className="space-y-3" data-id="element-98" data-mp="3v7zy1j4mj2od">
              <li data-id="element-99" data-mp="3v918pmhq9n5k">
                <a href="#" className="text-white/50 hover:text-amber-400 transition-colors text-sm font-light" data-id="element-100" data-mp="3v5dfkog732rd">
                  Reparación de Crédito
                </a>
              </li>
              <li data-id="element-101" data-mp="34p6x15ihif3">
                <a href="#" className="text-white/50 hover:text-amber-400 transition-colors text-sm font-light" data-id="element-102" data-mp="335ph784d1bq">
                  Optimización de Perfil
                </a>
              </li>
              <li data-id="element-103" data-mp="qthyklf3p43w">
                <a href="#" className="text-white/50 hover:text-amber-400 transition-colors text-sm font-light" data-id="element-104" data-mp="qt05fxnqj607">
                  Fondeo Empresarial
                </a>
              </li>
              <li data-id="element-105" data-mp="twnzthrs0v1i">
                <a href="#" className="text-white/50 hover:text-amber-400 transition-colors text-sm font-light" data-id="element-106" data-mp="tt0bcx16uytn">
                  Asesoría Personalizada
                </a>
              </li>
            </ul>
          </div>

          {/* Compañía */}
          <div data-id="element-107" data-mp="18lu1dce36xck">
            <h3 className="text-white font-semibold mb-5 text-sm tracking-wide" data-id="element-108" data-mp="1cluormj5yivr">
              Compañía
            </h3>
            <ul className="space-y-3" data-id="element-109" data-mp="1hjw6a30xya54">
              <li data-id="element-110" data-mp="1hiulh6u4i9a7">
                <a href="#proceso" className="text-white/50 hover:text-amber-400 transition-colors text-sm font-light" data-id="element-111" data-mp="1hmife73hcxpg">
                  Nuestro Proceso
                </a>
              </li>
              <li data-id="element-112" data-mp="3oc6sl2g3h81m">
                <a href="#resultados" className="text-white/50 hover:text-amber-400 transition-colors text-sm font-light" data-id="element-113" data-mp="3ocpy1jok63yr">
                  Resultados
                </a>
              </li>
              <li data-id="element-114" data-mp="25of22d364alj">
                <a href="#faq" className="text-white/50 hover:text-amber-400 transition-colors text-sm font-light" data-id="element-115" data-mp="25nvkwylcdq8k">
                  Preguntas Frecuentes
                </a>
              </li>
              <li data-id="element-116" data-mp="1wpjsqs4tuke0">
                <a href="#" className="text-white/50 hover:text-amber-400 transition-colors text-sm font-light" data-id="element-117" data-mp="1wlw0dwb4c40v">
                  Contacto
                </a>
              </li>
            </ul>
          </div>

          {/* Contacto */}
          <div data-id="element-118" data-mp="2kfe578l8i6xq">
            <h3 className="text-white font-semibold mb-5 text-sm tracking-wide" data-id="element-119" data-mp="2fe6x18f6j5qj">
              Contacto
            </h3>
            <ul className="space-y-3" data-id="element-120" data-mp="18ynwnitc930y">
              <li data-id="element-121" data-mp="18zpfwakicvtr">
                <a href="tel:+14073678672" className="text-white/50 hover:text-amber-400 transition-colors text-sm font-light" data-id="element-122" data-mp="18w1qnnm3ivku">
                  +1 (407) 367-8672
                </a>
              </li>
              <li data-id="element-123" data-mp="2wnhl7uxfpubi">
                <a href="mailto:eduardo@vantixcreditsolutions.com" className="text-white/50 hover:text-amber-400 transition-colors text-sm font-light" data-id="element-124" data-mp="2wo0t0itdf2bt">
                  eduardo@vantixcreditsolutions.com
                </a>
              </li>
              <li className="text-white/50 text-sm font-light" data-id="element-125" data-mp="3bk8dlk8oy5rm">
                Miami · Houston · Los Angeles
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-white/40" data-id="element-126" data-mp="31mc2gsfr7ati">
          <p data-id="element-127" data-mp="36isu3wm5w7bc">
            © {new Date().getFullYear()} Vantix Credit Solutions. Todos los
            derechos reservados.
          </p>
          <div className="flex gap-6" data-id="element-128" data-mp="1v5764es1gbre">
            <a href="#" className="hover:text-amber-400 transition-colors" data-id="element-129" data-mp="1v69t4bm8pu21">
              Privacidad
            </a>
            <a href="#" className="hover:text-amber-400 transition-colors" data-id="element-130" data-mp="1nk4ncyhjbeqn">
              Términos
            </a>
            <a href="#" className="hover:text-amber-400 transition-colors" data-id="element-131" data-mp="1ip7epso637ea">
              Aviso Legal
            </a>
          </div>
        </div>
      </div>
    </footer>;
}